import axios from "../../../axios";
import { addNotification } from "../../../Utilities/notifications";

export const deleteUser = async (user_id, org_id) => {
    try {
        let { status } = await axios.delete(`${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/organization/${org_id}/users/${user_id}`);
        if(status === 204){
            addNotification({
                title: "Techforce.ai",
                message: "User has been removed from organization Successfully",
                type: "success"
            });
        }
    } catch (err) {
        console.log("error while creating organization", err.message);
        addNotification({
          title: "Techforce.ai",
          message: "Please write to technical support..",
          type: "danger"
        });
    }
};
